<du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.QUERY, appName]}">
    <detail-header>
        @if (logoUrl && logoUrl.length > 0) {
            <img
                    [ngSrc]="logoUrl"
                    alt="{{appName}} logo"
                    width="64" height="64" priority>
        }
        <div>
            <h1 class="detail-header-title">
                {{ appName }}
            </h1>
            <p class="detail-header-subtitle">
                {{ "#" + id }}
            </p>
        </div>
    </detail-header>
    <detail-body>
        <p-card class="query-detail-card">
                <div class="metadata-grid">
                    <div class="metadata-item">
                        <span class="metadata-label">{{ 'query.appVersion' | translate }}</span>
                        <span class="metadata-value">{{ appVersion }}</span>
                    </div>
                    <div class="metadata-item">
                        <span class="metadata-label">{{ 'query.dialect' | translate }}</span>
                        <span class="metadata-value">{{ dialect }}</span>
                    </div>
                    @if (parameterInputs.length > 0) {
                        <div class="metadata-item metadata-item--parameters">
                            <span class="metadata-label">{{ 'query.parameters' | translate }}</span>

                            <p-button severity="secondary" [outlined]="true"
                                      (click)="parameterPopover.toggle($event); $event.stopPropagation()">
                                {{ parameterInputs.length }} {{ 'query.parameters' | translate }}
                                <i class="pi pi-chevron-down"></i>
                            </p-button>
                            <p-popover #parameterPopover>
                                <div class="parameter-popover">
                                    @for (parameter of parameterInputs; track parameter.index) {
                                        <div class="field">
                                            <label>{{ '{' + parameter.index + '}' }}</label>
                                            <input
                                                    pInputText
                                                    [(ngModel)]="parameter.value"
                                                    (ngModelChange)="updateModels()"
                                                    [name]="'parameter-' + parameter.index">
                                        </div>
                                    }
                                </div>
                            </p-popover>
                        </div>
                    }
                </div>

                @if (!isComparisonActive) {
                    <div class="editor-container">
                        <div class="editor-header">
                            <i class="pi pi-code"></i>
                            <span>{{ queryName }}</span>
                            @if (this.allVersions.length > 0) {
                                <div class="version-selector">
                                    <p-select [ngModel]="id" (ngModelChange)="queryDetail($event)"
                                                  [options]="versionOptions" optionLabel="version" optionValue="id" placeholder="Version"/>
                                </div>
                                <div class="compare-selector">
                                    <p-select [(ngModel)]="selectedSecondVersionId" (ngModelChange)="secondVersion($event)"
                                                  [options]="compareOptions" optionLabel="version" optionValue="id"/>
                                </div>
                            } @else {
                                <span style="margin-left: auto">v{{ queryVersion }}</span>
                            }
                        </div>
                        <div class="editor">
                            <ngx-monaco-editor [options]="editorOptions"
                                               [ngModel]="code"></ngx-monaco-editor>
                        </div>
                    </div>
                } @else {
                    <div class="editor-container">
                        <div class="editor-header">
                            <i class="pi pi-code"></i>
                            <div class="version-label">
                                {{ 'query.queryVersion' | translate }}: {{ selectedFirstVersion?.version }}
                            </div>
                            <div class="version-label form">
                                <div class="compare-selector">
                                    <p-select [(ngModel)]="selectedSecondVersionId" (ngModelChange)="secondVersion($event)"
                                                  [options]="compareOptionsStop" optionLabel="version" optionValue="id" [placeholder]="'query.compare' | translate"/>
                                </div>
                            </div>
                            <p-button [rounded]="true" [text]="true" severity="secondary" (click)="stopComparing()"><i class="pi pi-times"></i></p-button>
                        </div>
                        <div class="editor">
                            <ngx-monaco-diff-editor
                                    [options]="options"
                                    [originalModel]="originalModel"
                                    [modifiedModel]="modifiedModel">
                            </ngx-monaco-diff-editor>
                        </div>
                    </div>
                }
                <div class="editor-actions">
                    @if (parameterInputs.length > 0) {
                        <p-button severity="secondary" (click)="testQuery()">
                            <i class="pi pi-check-circle"></i>
                            {{ 'button.test' | translate | uppercase }}
                        </p-button>
                    }
                    <p-button severity="danger" [outlined]="true" (click)="deleteQuery()">
                        <i class="pi pi-trash"></i>
                        {{ 'button.delete' | translate | uppercase }}
                    </p-button>
                    <p-button severity="secondary" (click)="editQuery()">
                        <i class="pi pi-pencil"></i>
                        {{ 'button.edit' | translate | uppercase }}
                    </p-button>
                    <p-button (click)="createQuery()">
                        <i class="pi pi-plus"></i>
                        {{ 'button.create' | translate | uppercase }}
                    </p-button>
                </div>
        </p-card>
    </detail-body>
</du-config-detail>
